<template>
  <div>
    <div
      v-for="(foods, subCategoryId) in foodGroupedBy(foodByCategory)"
      :key="subCategoryId"
    >
      <h3 v-if="hasSubCategory(subCategoryId)" class="subcategory-name">
        {{ getSubCategoryName(subCategoryId) }}
      </h3>

      <template v-for="(food, index) in foods">
        <li
          :key="index"
          class="product-row food-products"
          :style="{ 'background-color': '#FFFFFF' }"
        >
          <div class="flex-wrapper">
            <h4 class="product-name" :style="{ color: listItemNameColorTheme }">
              {{ translate("name", food) }}
            </h4>

            <div class="product-meta">
              <AddToCartFood :isAdmin="isAdmin" :food="food"></AddToCartFood>
            </div>
          </div>

          <div
            class="description"
            :style="{ color: listItemDescriptionColorTheme }"
          >
            {{ translate("description", food) }}
          </div>

          <Allergens :product="food"></Allergens>
          <div v-if="food.isAllowProductStory">
            <v-btn
              class="mt-3 gradient-border"
              outlined
              small
              fab
              color="white"
              @click="storyDialogAction(food.productStory)"
            >
              <v-icon style="color: black !important;">mdi-camera</v-icon>
            </v-btn>
          </div>
        </li>
      </template>
    </div>
    <StoryDialog
      v-if="storyDialog && storyUrl !== ''"
      :openDialog.sync="storyDialog"
      :storyUrl="storyUrl"
    />
  </div>
</template>

<script>
import AddToCartFood from "../../cart/AddToCartFood";
import Allergens from "../Allergens/Allergens";
import StoryDialog from "@/components/admin/product/productstory/StoryDialog";

export default {
  name: "ListFood",
  props: {
    categoryName: String,
    foodByCategory: Array,
    subCategories: Array,
    isAdmin: Boolean
  },
  components: {
    AddToCartFood,
    Allergens,
    StoryDialog
  },
  data() {
    return {
      storyDialog: false,
      storyUrl: ""
    };
  },
  methods: {
    storyDialogAction(videoUrl) {
      if (videoUrl !== "" && videoUrl !== undefined) {
        this.storyUrl = videoUrl;
        this.storyDialog = true;
      }
    },
    hasSubCategory(id) {
      return this.getSubCategoryName(id) !== "";
    },
    getSubCategoryName(id) {
      const subCategory = this.subCategories.find(
        subCategory => id === subCategory.id
      );
      return subCategory ? subCategory.name : "";
    },
    foodGroupedBy(products, key = "sub_category_id") {
      return this.arrayGroupBy(products, key);
    }
  }
};
</script>
